import FeedbackVideoTestimonialModule from './FeedbackVideoTestimonialModule'

export default FeedbackVideoTestimonialModule
